<template>
  <div>
    <el-form 
      class="status-form" 
      @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-6">
          <base-input 
            v-uppercase 
            v-model="status.label" 
            label="Name" 
            style="width:470px"/>
          <base-input 
            v-model="code" 
            label="Code" 
            style="width:470px"/>
        </div>
      </div>
      <base-button 
        md 
        type="primary" 
        native-type="submit">Save</base-button>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Select, Option, Form } from "element-ui";

export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  data: () => {
    return {};
  },

  computed: {
    ...mapState("status", ["status"]),
    code: {
      get() {
        return this.status.label
          .split(" ")
          .join("_")
          .toLowerCase();
      },
      set(value) {
        return value;
      }
    }
  },
  methods: {
    ...mapActions({
      saveStatus: "status/saveStatus",
      getStatusList: "status/getStatusList",
      updateStatus: "status/updateStatus"
    }),
    onSubmit() {
      if (this.status.statusId) {
        this.status.code = this.code;
        this.updateStatus().then(res => {
          this.$notify({
            message: "Status Updated Succesfully!",
            type: "success",
            title: "Succes"
          });
          this.getStatusList();
          this.$emit("close");
        });
      } else {
        this.status.code = this.code;
        this.saveStatus().then(res => {
          this.$notify({
            message: "Status Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getStatusList();
          this.$emit("close");
        });
      }
    }
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form
  }
};
</script>